import { useRef } from "react";
import { TbClipboardPlus } from "react-icons/tb";

const NotesNode = ({ data }) => {
    const ref = useRef(null);
    return (
        <div className="default_node notes_node">
            <div className="custom-node-content">
                <div className="custom-node-title">
                    <i><TbClipboardPlus /></i>
                    <span style={{ marginLeft: 6 }}>
                        {data?.meta?.label || "Note"}
                    </span>
                </div>

                <div className="notes_body">
                    {data?.params}
                </div>
            </div>
        </div>
    );
};

export default NotesNode;